import styled from "styled-components";

export const TableItem = styled.div`
  text-align: left;
  width: 25%;
  padding: 0 2rem;
`;
